module.exports = __webpack_public_path__ + "static/media/ProximaNova-LightIt.4f987e17.eot";